var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP1000Tip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 254,
    viewBox: "0 0 25 254",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0822 192.737H9.99289C9.72503 192.737 9.51074 192.483 9.51074 192.166L9.51074 184.737H15.5107V192.166C15.5107 192.483 15.2965 192.737 15.0822 192.737Z",
    fill: "#99B2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.51074 122.737H12.5107V167.737H8.51074C8.51074 167.737 7.93931 138.937 4.51074 122.737Z",
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5107 122.737H12.5107V167.737H16.5107C16.5107 167.737 17.0822 138.937 20.5107 122.737Z",
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.51074 123.737H16.5107V186.737C16.5107 187.842 15.6153 188.737 14.5107 188.737H10.5107C9.40617 188.737 8.51074 187.842 8.51074 186.737V123.737Z",
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5107 106.737H2.51074L2.51074 122.737C2.51074 123.842 6.98789 124.737 12.5107 124.737C18.0336 124.737 22.5107 123.842 22.5107 122.737L22.5107 106.737Z",
    fill: "#CCD8E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5076 109.691L24.5076 27.7368C24.5076 26.3294 23.7534 25.6436 22.5193 25.0404L18.1313 22.8958L12.5777 20.282L6.40711 23.2309L2.56761 25.0404C1.26493 25.6436 0.510742 26.85 0.510742 28.2574L0.510742 109.737C0.510742 110.841 5.88332 111.737 12.5107 111.737C19.1382 111.737 24.5107 110.841 24.5107 109.737C24.5107 109.721 24.5097 109.706 24.5076 109.691Z",
    fill: "#F5F7F9"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 20,
    width: 25,
    height: 92
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5076 109.691L24.5076 27.7368C24.5076 26.3294 23.7534 25.6436 22.5193 25.0404L18.1313 22.8958L12.5777 20.282L6.40711 23.2309L2.56761 25.0404C1.26493 25.6436 0.510742 26.85 0.510742 28.2574L0.510742 109.737C0.510742 110.841 5.88332 111.737 12.5107 111.737C19.1382 111.737 24.5107 110.841 24.5107 109.737C24.5107 109.721 24.5097 109.706 24.5076 109.691Z",
    fill: "#F5F7F9"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.510742,
    y: 24.7368,
    width: 6,
    height: 87,
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.5107,
    y: 24.7368,
    width: 6,
    height: 87,
    fill: "#E5ECF0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.5773 20.6848C15.1522 20.6848 17.2395 19.8746 17.2395 18.8752C17.2395 17.8758 15.1522 17.0657 12.5773 17.0657C10.0024 17.0657 7.91504 17.8758 7.91504 18.8752C7.91504 19.8746 10.0024 20.6848 12.5773 20.6848Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3525 21.7563C19.9813 19.6117 17.8558 18.0032 15.4561 17.333C14.9762 17.6681 13.8792 17.8692 12.508 17.8692C11.2053 17.8692 10.1768 17.6681 9.62834 17.4C7.22865 18.1373 5.03466 19.6117 3.66341 21.8234C3.18347 22.6276 2.97778 23.6329 2.97778 24.5712L2.97778 33.753C2.97778 34.4902 3.66341 35.0264 4.41759 34.9593C6.68015 34.5572 9.35409 34.2891 12.3023 34.2891C15.4561 34.2891 18.1986 34.5572 20.5983 34.9593C21.3525 35.0934 22.0381 34.5572 22.0381 33.753L22.0381 24.4372C22.0381 23.4989 21.8324 22.5606 21.3525 21.7563Z",
    fill: "#54BCE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.94214 23.2981C4.90201 22.0247 6.27326 21.0864 7.71307 20.3492C8.46726 20.0141 9.22144 19.746 10.0442 19.5449C10.8669 19.3439 11.6897 19.2769 12.5124 19.2769C14.1579 19.2769 15.872 19.612 17.3118 20.3492C18.8202 21.0194 20.1229 22.0247 21.0827 23.2981C19.7115 22.4268 18.3402 21.7566 16.9004 21.2875C16.1462 21.0864 15.4606 20.8853 14.7064 20.7513C13.9523 20.6173 13.1981 20.5502 12.4439 20.5502C10.9355 20.5502 9.42713 20.8183 7.98732 21.2204C6.68464 21.7566 5.24482 22.4268 3.94214 23.2981Z",
    fill: "#3295BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5107 55.7368H8.51074L8.51074 83.6483H16.5107L16.5107 55.7368Z",
    fill: "#54BCE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8386 61.3699H10.2803L10.2803 77.5956H14.8386L14.8386 61.3699Z",
    fill: "#FBF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8386 61.3699H10.2803V61.7061H14.8386V61.3699Z",
    fill: "#A49448"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8386 77.3433H10.2803V77.6796H14.8386V77.3433Z",
    fill: "#A49448"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8386 72.0466H10.2803V72.3829H14.8386V72.0466Z",
    fill: "#A49448"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8386 66.666H10.2803V67.0023H14.8386V66.666Z",
    fill: "#A49448"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.629 62.9751C12.9313 62.9751 13.1713 63.0588 13.3491 63.2261C13.5284 63.392 13.618 63.6136 13.618 63.891C13.618 64.1024 13.5511 64.3314 13.4175 64.578C13.2853 64.8245 13.0521 65.1511 12.7179 65.5577H13.8094V66.0905H11.7471V66.0267C11.9871 65.7405 12.193 65.4836 12.3646 65.2561C12.5378 65.0271 12.6715 64.8378 12.7657 64.688C12.8599 64.5369 12.9267 64.4084 12.9662 64.3027C13.0057 64.1971 13.0255 64.0877 13.0255 63.9747C13.0255 63.8338 12.9784 63.7156 12.8842 63.6202C12.7915 63.5233 12.6784 63.4749 12.5447 63.4749C12.3046 63.4749 12.0555 63.607 11.7972 63.8712V63.2679C12.0691 63.0727 12.3464 62.9751 12.629 62.9751Z",
    fill: "#DB0300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7931 68.2437C13.1151 68.2437 13.3704 68.3838 13.5587 68.6642C13.7486 68.9445 13.8436 69.3276 13.8436 69.8135C13.8436 70.3037 13.7502 70.6905 13.5633 70.9738C13.3764 71.2571 13.1212 71.3987 12.7976 71.3987C12.4695 71.3987 12.2097 71.2585 12.0183 70.9782C11.8283 70.6964 11.7334 70.3111 11.7334 69.8223C11.7334 69.335 11.8283 68.9504 12.0183 68.6686C12.2082 68.3853 12.4664 68.2437 12.7931 68.2437ZM12.3259 69.8399C12.3259 70.543 12.4816 70.8945 12.7931 70.8945C13.0969 70.8945 13.2488 70.5246 13.2488 69.7849C13.2488 69.0935 13.0954 68.7478 12.7885 68.7478C12.4801 68.7478 12.3259 69.1119 12.3259 69.8399Z",
    fill: "#101620"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7989 73.4827C13.121 73.4827 13.3762 73.6228 13.5646 73.9032C13.7545 74.1835 13.8495 74.5666 13.8495 75.0525C13.8495 75.5427 13.756 75.9295 13.5692 76.2128C13.3823 76.4961 13.1271 76.6377 12.8035 76.6377C12.4753 76.6377 12.2155 76.4976 12.0241 76.2172C11.8342 75.9354 11.7393 75.5501 11.7393 75.0613C11.7393 74.574 11.8342 74.1894 12.0241 73.9076C12.214 73.6243 12.4723 73.4827 12.7989 73.4827ZM12.3318 75.0789C12.3318 75.782 12.4875 76.1335 12.7989 76.1335C13.1028 76.1335 13.2547 75.7636 13.2547 75.0239C13.2547 74.3325 13.1012 73.9869 12.7944 73.9869C12.486 73.9869 12.3318 74.3509 12.3318 75.0789Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9718 24.7723V33.753C21.9718 34.4903 21.3547 35.0264 20.532 34.8924C19.7778 34.7583 18.955 34.6913 18.0637 34.5573L18.0637 23.1638C19.1607 23.5659 19.7778 23.901 20.7377 24.3032C21.4918 24.5042 21.4918 24.5042 21.9718 24.7723Z",
    fill: "#3295BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.04785 24.7743L3.04785 33.755C3.04785 34.4922 3.66491 35.0284 4.48766 34.8943C5.24185 34.7603 6.0646 34.6933 6.95591 34.5592L6.95591 23.1658C5.85891 23.5679 5.24185 23.903 4.28197 24.3051C3.52779 24.5062 3.52779 24.5062 3.04785 24.7743Z",
    fill: "#3295BA"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M7.80005 187.064L17.8 187.064L17.8 189.064L7.80005 189.064L7.80005 187.064Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 187,
    width: 10,
    height: 65
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.30029 187.064L17.3004 187.064L16.8003 204.064L16.2512 204.064L15.8002 213.064L15.2618 213.064L13.8003 251.068L11.8003 251.065L10.3388 213.064L9.80022 213.064L9.35034 204.064L8.8003 204.064L8.30029 187.064Z",
    fill: "#C6EDFC"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M7.80054 187.091L17.8004 187.036L17.3381 204.039L8.44936 204.088L7.80054 187.091Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M7.88818 203.091L17.888 203.036L17.6727 213.037L8.21332 213.089L7.88818 203.091Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M9.93774 212.08L15.9377 212.047L14.1517 251.057L12.1517 251.068L9.93774 212.08Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M12.3002 251.065L10.306 188.077L8.30601 188.088L7.8004 251.073L12.3002 251.065Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M13.3001 251.06L15.3058 188.05L17.3057 188.039L17.8001 251.06L13.3001 251.06Z",
    fill: "#C6EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8005 189.064L7.80029 189.064L7.81177 190.091L17.8003 190.064L17.8005 189.064ZM8.04634 204.09L16.8937 204.041L16.8686 205.042L7.89929 205.091L8.04634 204.09ZM10.0431 213.079L15.8431 213.047L15.8285 214.047L9.94864 214.08L10.0431 213.079Z",
    fill: "#333333"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -2.19434,
    y: -0.936035,
    width: 30,
    height: 259,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 253,
    fill: "white",
    transform: "translate(0.805664 0.0639648)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 253,
    fill: "white",
    transform: "translate(0.805664 0.0639648)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 64,
    fill: "white",
    transform: "translate(7.80029 187.064)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 64,
    fill: "white",
    transform: "translate(7.80029 187.064)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP1000Tip);
export default __webpack_public_path__ + "static/media/P1000-Tip.a993c930cacf7ea16e1596177eaf71d0.svg";
export { ForwardRef as ReactComponent };